"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKYCComponent = void 0;
var _KYC_IM = _interopRequireDefault(require("../KYC_IM"));
var _KYC_IMLegacy = _interopRequireDefault(require("../KYC_IMLegacy"));
var _KYC_Jumio = _interopRequireDefault(require("../KYC_Jumio"));
var _KYC_Manual = _interopRequireDefault(require("../KYC_Manual"));
var _KYC_AcuantGo = _interopRequireDefault(require("../KYC_AcuantGo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getKYCComponent = exports.getKYCComponent = function getKYCComponent(kycConfig) {
  switch (kycConfig.type) {
    case 'AG':
      return _KYC_AcuantGo["default"];
    case 'IM':
    case 'IMLegacy':
      return _KYC_IMLegacy["default"];
    case 'IM3.2':
      return _KYC_IM["default"];
    case 'Jumio':
      return _KYC_Jumio["default"];
    case 'Manual':
    case 'HTML':
      return _KYC_Manual["default"];
    default:
      return null;
  }
};